import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer } from '@angular/core';
import { isTrueProperty } from '../../utils/util';

import { ImageLoaderController } from './image-loader';
import { ConfigProvider } from '../../config/config';

const propMap: any = {
  display: 'display',
  height: 'height',
  width: 'width',
  backgroundSize: 'background-size',
  backgroundRepeat: 'background-repeat'
};


export class ImageLoaderCmp implements OnInit {
  private _src: string;

  
  set src(imageUrl: string) {
    this._src = this.processImageUrl(imageUrl);
    this.updateImage(this._src);
  }

  get src(): string {
    return this._src;
  }

   cache: boolean = true;
   fallbackUrl: string = this.config.get().imageLoader.fallbackUrl;
   spinner: boolean = this.config.get().imageLoader.spinnerEnabled;
   fallbackAsPlaceholder: boolean = this.config.get().imageLoader.fallbackAsPlaceholder;
   useImg: boolean = this.config.get().imageLoader.useImg;
   width: string = this.config.get().imageLoader.width;
   height: string = this.config.get().imageLoader.height;
   display: string = this.config.get().imageLoader.display;
   backgroundSize: string = this.config.get().imageLoader.backgroundSize;
   backgroundRepeat: string = this.config.get().imageLoader.backgroundRepeat;
   spinnerName: string = this.config.get().imageLoader.spinnerName;
   spinnerColor: string = this.config.get().imageLoader.spinnerColor;

  
  load: EventEmitter<ImageLoaderCmp> = new EventEmitter<ImageLoaderCmp>();

  isLoading: boolean = true;

  private element: HTMLElement;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer,
    private imageLoader: ImageLoaderController,
    private config: ConfigProvider
  ) { }

  ngOnInit(): void {
    this.useImg = isTrueProperty(this.useImg);
    this.cache = isTrueProperty(this.cache);
    this.fallbackAsPlaceholder = isTrueProperty(this.fallbackAsPlaceholder);

    if (this.fallbackAsPlaceholder && this.fallbackUrl) {
      this.setImage(this.fallbackUrl, false);
    }

    if (!this.src) {
      if (!this.fallbackAsPlaceholder && this.fallbackUrl) {
        this.setImage(this.fallbackUrl);
        return;
      }
      this.isLoading = false;
    }
  }

  private processImageUrl(imageUrl: string): string {
    if (this.cache === false) {
      if (imageUrl.indexOf('?') === -1) {
        imageUrl += '?';
      }

      if (['&', '?'].indexOf(imageUrl.charAt(imageUrl.length)) === -1) {
        imageUrl += '&';
      }

      imageUrl += 'cache_buster=' + Date.now();
    }

    return imageUrl;
  }

  private updateImage(imageUrl: string) {
    this.imageLoader.getImagePath(imageUrl).then((imageUrl: string) => this.setImage(imageUrl))
      .catch(() => this.setImage(this.fallbackUrl || imageUrl));
  }

  private setImage(imageUrl: string, stopLoading: boolean = true): void {
    this.isLoading = !stopLoading;

    if (this.useImg) {
      if (!this.element) {
        this.element = this.renderer.createElement(this.elementRef.nativeElement, 'img');
      }
      if (this.fallbackUrl && !this.imageLoader.nativeAvailable) {
        this.renderer.listen(this.element, 'error', () => {
          this.imageLoader.removeCacheFile(imageUrl);
          this.renderer.setElementAttribute(this.element, 'src', this.fallbackUrl);
        });
      }
      this.renderer.setElementAttribute(this.element, 'src', imageUrl);
    } else {
      this.element = this.elementRef.nativeElement;

      for (let prop in propMap) {
        if (this[prop]) {
          this.renderer.setElementStyle(this.element, propMap[prop], this[prop]);
        }
      }

      this.renderer.setElementStyle(this.element, 'background-image', 'url(\'' + (imageUrl || this.fallbackUrl) + '\')');
    }
    this.load.emit(this);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ion-image-loader',
  template: `
    <ion-spinner *ngIf="spinner && isLoading && !fallbackAsPlaceholder" [name]="spinnerName" [color]="spinnerColor"></ion-spinner>
    <ng-content></ng-content>
  `,
  styles: [`
    ion-spinner {
      float: none;
      display: block;
      margin: auto;
    }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: ImageLoaderController, },
{type: ConfigProvider, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'src': [{ type: Input },],
'cache': [{ type: Input },],
'fallbackUrl': [{ type: Input, args: ['fallback', ] },],
'spinner': [{ type: Input },],
'fallbackAsPlaceholder': [{ type: Input },],
'useImg': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'display': [{ type: Input },],
'backgroundSize': [{ type: Input },],
'backgroundRepeat': [{ type: Input },],
'spinnerName': [{ type: Input },],
'spinnerColor': [{ type: Input },],
'load': [{ type: Output },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
